import { useQuery } from "@tanstack/react-query";
import { NotificationCenterKeys } from "web_myplann/Api/NotificationCenter/notificationCenterKeys";
import {
	useDocumentsFeatureOptional,
	useRemindersRightOptional,
} from "web_myplann/Api/Rights/RightsProvider";
import {
	getNotificationCenterResolvingNowV2,
	type TimelineResponseDTO,
	type UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponseQuery } from "web_myplann/Infrastructure/Api/ApiUtils";
import { filterTimelineItemsByRights } from "web_myplann/NotificationCenter/Utils/filterTimelineItemsByRights";

import { resolveDocumentsOnlyFilter } from "web_myplann/NotificationCenter/Utils/resolveDocumentsOnlyFilter";

const STALE_TIME_MS = 60_000;

interface ResolvingNowParams {
	type?: UpcomingTimelineItemTypeFilterEnum;
	limit?: number;
	documentsOnly?: boolean;
}

export const useResolvingNowQuery = (
	params?: ResolvingNowParams,
	options?: { enabled?: boolean },
) => {
	const hasRemindersRight = useRemindersRightOptional();
	const hasDocumentsFeature = useDocumentsFeatureOptional();
	const { documentsOnly, subcategories } = resolveDocumentsOnlyFilter(
		params?.documentsOnly,
		hasDocumentsFeature,
	);

	return useQuery({
		queryKey: NotificationCenterKeys.resolvingNow(
			params?.type,
			params?.limit,
			subcategories,
		),
		queryFn: processResponseQuery(() =>
			getNotificationCenterResolvingNowV2(
				params?.type,
				undefined,
				subcategories,
				params?.limit,
			),
		),
		enabled: options?.enabled ?? true,
		staleTime: STALE_TIME_MS,
		select: (data: TimelineResponseDTO) =>
			filterTimelineItemsByRights(data, {
				hasRemindersRight,
				hasDocumentsFeature,
				documentsOnly,
			}),
	});
};
